// import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
// import Loader from '../components/Loader'; 
import Footer from '../components/Footer';
import { footerEn } from '../data/footer';
import { navigationTop, navigationButtom } from '../params';
import { Link } from 'react-router-dom';
import ResearchTrainingInner from '../components/Compliance/ResearchTrainingInner';
import ResearchTrainingOverview from '../components/Compliance/ResearchTrainingOverview';
// import '../assets/scss/CoreLabsAboutUs.scss';
// import '../assets/scss/Articles.scss';
// import 'bootstrap/dist/css/bootstrap.min.css'; 




const navigationIntern = []

const crumb = [
  // { link: '//', text: 'Home' },
  { link: '//', text: 'Home' },

  { link: '/research/research-training', text: 'Research Training' },
  { link: '/research/research-training/online-training', text: 'Online Training' },



]



function OnlineTraining(props) {
  document.title = 'Online Training'
  const poster = '/uploads/core-labs.png'
  //const src = '/uploads/welcome.mp4'
  const headerData = {
    title: 'Online Training',
    crumb: crumb,
    navigationButtom: navigationButtom,
    navigationTop: navigationTop,
    applicationLinks: [{ text: 'Apply now', class: 'bordred', link: '/header/applynow' }],
  }


  
  return (
    <>
      <Navigation
        navigationIntern={navigationIntern}
        {...headerData}
        updateLang={props.updateLang}
      />
      <section className="space-block-60">
        <div className='container'>
            <div className='row-listing'>
                <ResearchTrainingOverview />
                <ResearchTrainingInner />
            </div>

          {/* <div className="d-flex justify-content-center">
              <Loader />
          </div> */}
        </div>
      </section>
      <Footer {...footerEn} />
    </>
  )
}

export default OnlineTraining;
